module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_01_sp-da5643e67ada64b4def7b341c8ca5877.png";